import React from 'react';
import classnames from 'classnames';

const Card = ({
	img,
	headline,
	text,
	openCard,
	isOpen,
}) => (
	<div 
		className={classnames("card")}
		onClick={openCard}>
		<img src={img} alt="Einfache Einbindung durch Bettergood" />
		<h1>{headline}</h1>
		<div className="card__text">
			<p>
				{text}
			</p>
		</div>
	</div>
);

export default Card;


// WEBPACK FOOTER //
// ./src/business/Card.js